var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSetup)?_c('age-verification-setup',{attrs:{"processing":_vm.processing},on:{"cancel":_vm.onCancel,"finish":_vm.onFinish,"reset":_vm.onReset}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }